import React, {useContext, useEffect} from 'react';
import {FormattedMessage} from "react-intl";
import {Redirect} from "react-router-dom";

import store from "store";

import Grid from "@mui/material/Grid";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";

import StyledLine from "components/List/components/StyledLine";
import IconButton from "components/button/IconButton";
import EditIcon from "components/icons/EditIcon";
import {ListContext} from "components/List/context/ListContext";

import ShippingIcon from "../../../picking/components/shippingIcon";

import Header from "./components/Header";
import ActiveButton from "./components/ActiveButton";
import ShippingMethodName from "./components/ShippingMethodName";
import ShippingMethodForm from "../ShippingMethodForm";

import {list} from "api/shippingMethod/list";

import {Authorizations, hasAuthorization} from "utils/authorizations";

function ShippingMethodList(props) {
    const {
        setLoading,
        isCreateDialogOpen,
        closeCreateDialog,
        openCreateDialog,
        setListItems,
        setNotFilteredListItems,
        listItems
    } = useContext(ListContext)

    const authorizations = store.getState().authentication?.authorizations;

    // componentDidMount
    useEffect(() => {
        if (false === hasAuthorization(authorizations, Authorizations.MARKETPLACE_SHIPPING_METHODS_MANAGEMENT)) {
            return <Redirect to={'/'} />;
        }

        getShippingMethods();
    }, []);

    function getShippingMethods() {
        setLoading(true)

        list('order[updatedAt]=desc').then((response) => {
            if (!response) {
                return <Redirect to={'/'} />;
            }

            setListItems(response);
            setNotFilteredListItems(response);

            setLoading(false);
        })
    }

    return (
        <Grid container>
            <Header />
            <Grid item container>
                {listItems.map((shippingMethod, index) => (
                    <Grid
                        item
                        container
                        key={shippingMethod.id}
                        sx={{padding: '8px 0'}}
                    >
                        <StyledLine
                            justifyContent={"space-between"}
                            alignItems={'center'}
                            {...props}
                        >
                            <Grid
                                item
                                container
                                xs={4}
                                columnSpacing={2}
                                alignItems={'center'}
                            >
                                <Grid item>
                                    <ShippingIcon
                                        shippingMethod={shippingMethod}
                                        noCircle={true}
                                        size={'xs'}
                                    />
                                </Grid>
                                <Grid item>
                                    <ShippingMethodName name={shippingMethod.name} />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                xs={4}
                                columnSpacing={2}
                                justifyContent={'space-between'}
                            >
                                <Grid item>
                                    <FormattedMessage id={`shippingMethods.discr.${shippingMethod.discr}`}/>
                                </Grid>
                                <Grid item>
                                    {shippingMethod.shopName}
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                xs={4}
                                columnSpacing={2}
                                justifyContent={'flex-end'}
                                flexWrap={'nowrap'}
                                alignItems={'center'}
                            >
                                <Grid item sx={{ width: '60px' }}>
                                    <ActiveButton
                                        shippingMethod={shippingMethod}
                                        onClick={() => getShippingMethods()}
                                    />
                                </Grid>
                                <Grid item sx={{ width: '80px' }}>
                                    <Grid item>
                                        <IconButton onMouseDown={(e) => {
                                            e.stopPropagation();
                                            openCreateDialog(shippingMethod)
                                        }}>
                                            <EditIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </StyledLine>
                    </Grid>
                ))}
            </Grid>
            <Dialog
                open={isCreateDialogOpen}
                onClose={() => closeCreateDialog()}
                maxWidth={'sm'}
                scroll={'body'}
            >
                <DialogContent>
                    <ShippingMethodForm refreshList={getShippingMethods} />
                </DialogContent>
            </Dialog>
        </Grid>
    );
}

export default ShippingMethodList;
